import { render } from "./ImagePreview.vue?vue&type=template&id=6d687c72&scoped=true"
import script from "./ImagePreview.vue?vue&type=script&lang=js"
export * from "./ImagePreview.vue?vue&type=script&lang=js"

import "./ImagePreview.vue?vue&type=style&index=0&id=6d687c72&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d687c72"]])

export default __exports__